<template>
  <div class="app-container">
    <!-- 待发货订单 -->
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待发货订单" name="todo">
        <todo-list ref="todoList">
          <!-- <template slot="toolbar-right">
            <span class="count">待发货订单信息（{{Count}}）</span>
          </template>-->
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="130" v-if="$permission.canWrite()">
              <template slot-scope="{row}">
                <el-button type="text" @click="create(row)">生成发货通知单</el-button>
              </template>
            </el-table-column>
          </template>
        </todo-list>
      </el-tab-pane>
      <!-- 发货通知单 -->
      <el-tab-pane label="发货通知单" name="info">
        <info-list ref="infoList">
          <template slot="toolbar-right" v-if="$permission.canWrite()">
            <el-button type="danger" @click="delRows">删除</el-button>
          </template>
          <template slot="column">
            <el-table-column label="操作" fixed="right" align="center" width="120">
              <template slot-scope="{row}">
                <el-button type="text" @click="onPrint(row)">打印</el-button>
                <template v-if="(row.Status==0||row.Status==3)&&$permission.canWrite()">
                  <el-button type="text" @click="editById(row.DeliveryDocId)">编辑</el-button>
                </template>
                <template v-else>
                  <el-button type="text" @click="details(row.DeliveryDocId)">查看</el-button>
                  <template v-if="row.Status==1&&$permission.canReview()">
                    <el-button type="text" @click="review(row.DeliveryDocId)">审核</el-button>
                  </template>
                </template>
              </template>
            </el-table-column>
          </template>
        </info-list>
      </el-tab-pane>
    </el-tabs>
    <todo-dialog ref="todoDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import todoList from "@/components/business/sales/deliveryrelease/todo/list";

import infoList from "@/components/business/sales/deliveryrelease/info/list";
import todoDialog from "@/components/business/sales/deliveryrelease/info/todoDialog";
import detailsDialog from "@/components/business/sales/deliveryrelease/info/detailsDialog";
import editDialog from "@/components/business/sales/deliveryrelease/info/editDialog";

export default {
  name: "delivery",
  mixins: [curdMixins],
  components: {
    todoList,
    infoList,
    todoDialog,
    detailsDialog,
    editDialog,
  },
  data() {
    return {
      api: require("@/api/sa/order").default,
      Count: 0,
      tabName: "todo",
    };
  },
  methods: {
    handleClick() {
      this.reload();
    },
    reload() {
      this.$refs.infoList.reload();
      // this.api.getToDelivery().then((res) => {
      //   this.Count = res.Data;
      // });
      // this.$refs[this.tabName + "List"].reload();
      // this.$nextTick(() => {
      //   this.$refs[this.tabName + "List"].$refs.list.$refs.table.doLayout();
      // });
    },
    onPrint(row) {
      let newpage = this.$router.resolve({
        path: "/deliveryPrint?id=" + row.DeliveryDocId,
      });
      window.open(newpage.href, "_blank");
    },
    create(data) {
      this.$refs.todoDialog.openCreate(data);
    },
    editById(id) {
      this.$refs.todoDialog.openEditById(id);
    },
    review(id) {
      this.$refs.detailsDialog.openEditById(id);
    },
    details(id) {
      this.$refs.detailsDialog.openDetailsById(id);
    },
    delRows() {
      let rows = this.$refs.infoList.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.DeliveryDocId;
          });
          this.$refs.infoList.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.count {
  margin-right: 15px;
  font-size: 14px;
  color: red;
  line-height: 28px;
}
</style>